import {useContext, useState} from "react";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import {containsXss} from "../../../utils/security/XssFilter";
import {DialogEnum, showDialog} from "../../../utils/dialog/Dialog";
import {IAM_SERVER_SERVICE_AUTH} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import styles from '../../../utils/modal/DetailModal.module.css';
import { InnocodeButton, InnocodeInput } from "@intsoft/innocode-core";


/**
 * 권한 등록 모달 Container
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const AuthRegisterModal = ({update, selectedServiceId, pageNameMap}) => {
    const {closeModal} = useContext(ModalContext);
    const [isNull, setIsNull] = useState(false); //빈 값 확인
    const [isDuplicateChecked, setIsDuplicateChecked] = useState(false); // 중복 확인 완료 여부

    const [formData, setFormData] = useState({
        serviceId: selectedServiceId,
        authorityName: '',
        authorityEngName: '',
        authorityDiscript: '',
        notModAuthority: false,
        authorityType: 'SERVICE', // 기본 최초 값
    });

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    const selectOption = (value) => {
        setFormData((prevState) => ({
            ...prevState,
            ['authorityType']: value
        }));
    }

    // 권한 등록 요청 API
    const handleRegister = () => {
        setIsNull(false); // 검사 전에 초기화

        // key를 순회하며 유효성 검사
        for (const key in formData) {
            const value = formData[key];

            if (key === 'authorityDiscript' || key === 'notModAuthority') {
                continue; // 다음 필드로 넘어감
            }

            //    (value === '' || value === null || value === undefined) 와 같이 더 엄격하게 체크할 수 있습니다.
            if (value.trim() === '') {
                showDialog(DialogEnum.DEFAULT, "입력 오류", "필수 항목을 모두 입력해주세요.");
                setIsNull(true);

                // 어떤 필드가 비었는지 알려주면 사용자 경험이 더 좋아집니다.
                console.error(`필수 필드 '${key}'가 비어있습니다.`);
                return; // 함수 종료
            }
            
            // XSS 검사
            if (containsXss(value)) {
                setFormData((prevState) => ({
                    ...prevState,
                    [key]: ''
                }));
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            }
        }
        
        const pageParams = {
            serviceId: formData.serviceId,
            authorityName: formData.authorityName,
            authorityEngName: formData.authorityEngName,
            authorityDiscript:formData.authorityDiscript,
            notModAuthority: formData.notModAuthority,
            authorityType:formData.authorityType
        }; 

        const url = IAM_SERVER_SERVICE_AUTH + "/create";
        axios.post(url, pageParams)
            .then((res) => {
                showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                update();
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            });
    }


    return (
        <div>
            <ul className={styles.layer__listWrap}>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>권한 명</p>
                    <InnocodeInput
                        type="text"
                        name="authorityName"
                        value={formData.authorityName}
                        onChange={(e) => handleChange(e)}
                        placeholder="권한명을 입력하세요"
                    />
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>영문 명</p>
                    <InnocodeInput
                        type="text"
                        name="authorityEngName"
                        value={formData.authorityEngName}
                        onChange={(e) => handleChange(e)}
                        placeholder="영문명을 입력하세요"
                    />
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>권한 타입</p>
                    <select
                        className={styles.layer__listInput}
                        name="authorityType"
                        value={formData.authorityType}
                        onChange={(e) => selectOption(e.target.value)}
                    >
                        <option value="SERVICE">서비스 유저 (SERVICE)</option>
                        <option value="TENANT">테넌트 유저 (TENANT)</option>
                        <option value="USER">일반 유저 (USER)</option>
                    </select>
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>설명</p>
                    <InnocodeInput 
                        type="text"
                        name="authorityDiscript"
                        value={formData.authorityDiscript}
                        onChange={(e) => handleChange(e)}
                        placeholder="권한 설명을 입력하세요"
                        multiline={true}
                        rows={4}
                    />
                </li>
            </ul>

            {isNull ? <div className={`${styles.layer__text} ${styles.warning}`}>빈 칸을 확인해 주세요.</div> : null}
            <div className={styles.layer__saveBtnBox}>
                <InnocodeButton
                    size="md" 
                    fullWidth={true}
                    className={styles.layer__saveBtn}
                    onClick={handleRegister}
                >등록</InnocodeButton>
            </div>
        </div>
    )
}